const relatedModules = {
  shipments: 'shipments',
  lots: 'lots',
  createShipment: 'createShipment',
};

export { relatedModules };
